import React, { Component } from 'react';
import Editbox from '../Part_Sample/Editbox';
import Button from '../Part_Sample/Button';
import ConfirmMessage from '../Part_Sample/ConfirmMessage';
import Dropdown from '../Part_Sample/Dropdown';
import Refresh from './Components/Refresh';
import { isEmpty, getHash } from '../Common/Common';

// import reiri_home_logo from '../../Images/Daikin_Images/Logos/Horizontal/ReiriHome_transparent.png';
// import reiri_office_logo from '../../Images/Daikin_Images/Logos/Horizontal/ReiriOffice_transparent.png';
//import reiri_home_logo from '../../Images/Daikin_Images/Logos/Horizontal/ReiriforHome_Logo.png';
//import reiri_office_logo from '../../Images/Daikin_Images/Logos/Horizontal/ReiriforOffice_Logo.png';
import reiri_logo from '../../Images/Daikin_Images/Logos/Horizontal/Reiri_Logo.png';

export default class Login_Page extends Component {
	constructor(props) {
		super(props);
		let username = '';
		let password = '';

		// Get the list of registered controllers names
		this.controller_names = window.localStorage.getItem('controller_names') == null ? [] : JSON.parse(window.localStorage.getItem('controller_names'));

		// Populate the dropdown list with controller names
		let drop_down_list = [];
		let li = {};

		for (let name of this.controller_names) {
			li = {};
			li.value = name;
			li.display = name;
			drop_down_list.push(li);
		}

		// Add another list item for adding controllers
		li = {};
		li.value = 'create_controller';
		li.display = this.props.receiver.getString('create_controller');
		drop_down_list.push(li);

		// Controller selection dropdown header
		let dropdown_header = 'Open Menu';

		// Check if previously already have an active controller, if yes get the controller information
		if (this.controller_names.length > 0 && this.props.receiver.is_mobile) {
			let controller_name = window.localStorage.getItem('active_controller_name');
			let controller_info = JSON.parse(window.localStorage.getItem(controller_name));

			// Auto populate the username and password input field
			if (controller_info != null) {
				username = controller_info.username == null ? '' : controller_info.username;
				password = controller_info.password == null ? '' : controller_info.password;
				// Set this as the active controller and create comm module
				this.props.receiver.setController(controller_info);
			}

			// Set the controller selection dropdown header to this controller name
			if (controller_name != null && controller_name != '') dropdown_header = controller_name;

			if (window.app) window.app.hideLoading();
		} else if (this.props.receiver.is_mobile && window.localStorage.getItem('is_terms_and_conditions_accepted') != 'true') {
			// If terms and conditions not already accepted, Need to start from onboading select language
			this.props.content_handler('Launch_Screen');
		} else if (!this.props.receiver.is_mobile) {
			// Allow the saving of current controller name
			let controller_names = window.localStorage.getItem('controller_names') == null ? [] : JSON.parse(window.localStorage.getItem('controller_names'));
			let controller_name = "Reiri" + window.location.hostname;

			if (!controller_names.includes(controller_name)) {
				this.web_controller_info = {
					"ip_addr": window.location.hostname,
					"name": controller_name,
					"ssc_connect": false,
					"username": "",
					"password": ""
				}

				// Save controller name in controller names
				controller_names.push(controller_name);
				window.localStorage.setItem('controller_names', JSON.stringify(controller_names));

				// Save controller information
				window.localStorage.setItem(controller_name, JSON.stringify(this.web_controller_info));

			} else {
				this.web_controller_info = JSON.parse(window.localStorage.getItem(controller_name));
				if (this.web_controller_info != null) {
					username = this.web_controller_info.username == null ? '' : this.web_controller_info.username;
					password = this.web_controller_info.password == null ? '' : this.web_controller_info.password;
				}
			}
			this.props.receiver.setController(this.web_controller_info);
		}

		// Check Lanaguage and set the app language
		let lang = 'EN';
		let language_header = 'English';
		if (window.localStorage.getItem('language') != null && window.localStorage.getItem('language') != '') {
			lang = window.localStorage.getItem('language');
			let language_list = this.props.receiver.getLanguageList();
			for (let i in language_list) {
				if (language_list[i].value == lang) {
					language_header = language_list[i].display;
				}
			}
		}

		this.state = {
			username: username,
			password: password,
			is_logged_in: false,
			dropdown_header: dropdown_header,
			drop_down_list: drop_down_list,
			login_status: '',
			// For Language
			language_header: language_header,
			lang: lang,
			is_show_confirm: false,
		}

		this.dropdown_ref = React.createRef();
		// For login precheck
		this.controller_info = {};
		// For deleting controller
		this.to_be_removed = '';
		// Click logo count
		// this.logo_clicked = 0;
		// checkInternet count
		this.check_internet = 0;

	}

	componentDidMount() {
		let controller_name = window.localStorage.getItem('active_controller_name');
		let controller_info = JSON.parse(window.localStorage.getItem(controller_name));

		// Auto login
		if (controller_info != null && controller_info.is_logged_in) {
			if (this.props.param != null && this.props.param != undefined) {
				// if this.props.param.is_from_error is true, do not auto login
				if (this.props.param.is_from_error) {
					return;
				}
			}
			this.handleLogin();
		}
	}

	/*handleClickLogo = () =>{
		this.logo_clicked +=1;
		if(this.logo_clicked >= 5){
			this.logo_clicked = 0;
			window.app.openConsole();
		}
	}*/

	checkInternet = () => {
		this.check_internet += 1;
		if (this.check_internet >= 5) {
			this.check_internet = 0;
			//this.props.content_handler('Check_Internet_Connectivity');
		}
	}

	handleChangeUsername = (val) => {
		this.setState({
			username: val
		})
	}

	handleChangePassword = (val) => {
		this.setState({
			password: val
		})
	}

	controllerNotFound = () => {
		window.app.hideLoading();
		this.setState({ login_status: '' });
		// Login will try to connect to ssc, 
		// if fail, try to connect locally,
		// If fail try ssc and local again
		// If fail again, try to search for controller in the network with the same mac address
		// If still fail, alert ws_err
		window.app.showToast(this.props.receiver.getString('ws_err'), 3000);
		return;
	}

	handleLogin = () => {
		// Reset reconnect attempt
		if (this.props.receiver.active_controller.comm_module.login_page_reconnect_attempt != 0) {
			this.props.receiver.active_controller.comm_module.login_page_reconnect_attempt = 0;
		}

		if (this.props.receiver.is_mobile && this.props.receiver.active_controller.ssc_connect) {
			window.FirebasePlugin.grantPermission(function (hasPermission) {
				// Check if app has permission 
				// If no permission, app will prompt user 
				console.log("Push notification permission was " + (hasPermission ? "granted" : "denied"));
			});

			if (window.app) window.app.showLoading();
			this.setState({ login_status: 'Getting FCM token...' })

			let fcm_token = window.localStorage.getItem('fcm_token');
			console.log('fcm_token: ' + fcm_token);

			if(fcm_token == null || fcm_token == '') {
				window.FirebasePlugin.getToken((fcmToken) => {
					window.localStorage.setItem('fcm_token', fcmToken);
	
					this.login(fcmToken);
				}, (error) => {
					console.error('FCM getToken error = ' + error);
					this.login();
				});
			} else {
				this.login(fcm_token);
			}			
		} else {
			this.login();
		}
	}

	login = (uuid) => {
		let user = {};
		user.username = this.state.username;
		user.password = this.state.password;
		user.uuid = uuid;
		this.setState({ login_status: 'Logging in...' })

		let controller_name = "Reiri" + window.location.hostname;

		if (this.props.receiver.is_mobile) {
			controller_name = window.localStorage.getItem('active_controller_name');
			if (controller_name == null || controller_name == '') {
				window.app.hideLoading();
				window.app.showToast(this.props.receiver.getString('no_controller'), 3000);
				return;
			}
		}

		let controller_info = JSON.parse(window.localStorage.getItem(controller_name));
		// saves the username and password so when the app restarts, username and password can be auto populated
		controller_info.username = this.state.username;
		controller_info.password = this.state.password;
		window.localStorage.setItem(controller_name, JSON.stringify(controller_info));

		// When cloud connection fails and IP address of controller is changed, 
		// Broadcast is activated to search for IP Address of controller in network
		// is_from_login_page is to identify that this is from login procedure
		this.props.receiver.stored_params.is_from_login_page = true;
		this.props.receiver.login(user);
	}

	handleSwitchController = (controller_name) => {
		if (controller_name == 'create_controller') {
			delete this.props.receiver.stored_params.is_from_login_page;
			this.props.content_handler('Find_Controller', { from: 'Login_Page' });
		} else {
			window.localStorage.setItem('active_controller_name', controller_name);
			let controller_info = JSON.parse(window.localStorage.getItem(controller_name));
			let username = '';
			let password = '';
			if (controller_info == null || controller_info == undefined) {
				controller_info = {};
			} else {
				username = controller_info.username;
				password = controller_info.password;
			}
			this.props.receiver.setController(controller_info);

			this.setState({
				dropdown_header: controller_name,
				username: username,
				password: password,
				login_status: '',
			});
		}
	}

	handleOnMouseMove = (controller_name) => {
		if (controller_name != 'create_controller') {
			this.to_be_removed = controller_name;
			this.setState({ is_show_confirm: true })
		}
	}

	onConfirm = (is_pressed_ok) => {
		this.setState({ is_show_confirm: false })
		if (is_pressed_ok) {
			let controller_name = this.to_be_removed;
			window.localStorage.removeItem(controller_name);

			this.controller_names.splice(this.controller_names.indexOf(controller_name), 1)
			window.localStorage.setItem('controller_names', JSON.stringify(this.controller_names));

			let active_controller_name = window.localStorage.getItem('active_controller_name');
			if (active_controller_name == controller_name) {
				window.localStorage.setItem('active_controller_name', '');
			}

			if (this.state.dropdown_header == controller_name) {
				this.props.receiver.setController(null);
				this.setState({
					dropdown_header: 'Open Menu',
					username: '',
					password: '',
					login_status: '',
				})
			}

			// Populate the dropdown list with controller names
			let drop_down_list = this.state.drop_down_list;

			for (let i in drop_down_list) {
				if (drop_down_list[i].value == controller_name) {
					drop_down_list.splice(i, 1);

					this.setState({ drop_down_list: drop_down_list });
					this.dropdown_ref.current.setState({ options: this.dropdown_ref.current.updateOptions(drop_down_list) });
					break;
				}
			}
		}
		this.to_be_removed = '';
	}

	handleChangeLanguage = (lang) => {
		let language_list = this.props.receiver.getLanguageList();
		for (let i in language_list) {
			if (language_list[i].value == lang) {
				this.setState({
					language_header: language_list[i].display,
					lang: lang,
				})
			}
		}

		this.props.receiver.setLanguage({ 'lang': lang });
		window.localStorage.setItem('language', lang);
	}

	render() {
		let logo_width = this.props.width > 525 ? this.props.width * 0.4 : this.props.width * 0.8;
		let logo_height = logo_width / 3;

		// 356 is height of login box
		// 84 is height of language selection dropdown
		let loginbox_margin_top = (this.props.height - logo_height - 356 - 84) / 3;
		if (loginbox_margin_top < 0) loginbox_margin_top = 0;

		let loginBoxStyle = {
			textAlign: 'center',
			backgroundColor: 'hsla(0, 0%, 100%, 0.84)',
			width: this.props.width > 525 ? '60%' : this.props.width - 30,
			borderRadius: 10,
			padding: 10,
			marginLeft: 'auto',
			marginRight: 'auto',
			marginTop: loginbox_margin_top,
		}

		let dropdown_right_margin = (this.props.width - 200) / 2;
		let drop_down_left = (this.props.width - 165) / 2;
		if (drop_down_left < 0) drop_down_left = 0;

		let list = this.props.receiver.getLanguageList();

		// when app first started, active_controller is null, app will crash if we try to get the name
		let controller_info = {}
		if (this.props.receiver.active_controller != null) {
			controller_info = JSON.parse(window.localStorage.getItem(this.props.receiver.active_controller.name));
			if (isEmpty(controller_info)) controller_info = {};
		}

		// Check version number, if null or undefined, dont show
		let system_version = '';
		if (controller_info.version != null && controller_info.version != undefined) system_version = "Ver " + controller_info.version;
		let app_version = "Ver " + this.props.receiver.app_version;

		let refresh_component = null;
		// Refresh component
		if (this.props.receiver.active_controller != null && this.props.receiver.active_controller != undefined) {
			if (this.props.receiver.active_controller.model == 'F10' && !this.props.receiver.is_mobile) {
				refresh_component = <Refresh width={this.props.width - 180} />
			}
		}

		let logo = 'for Office';
		if (this.props.receiver.app_model == 'H') logo = 'for Home';

		return (
			<div className='noScrollBar' style={{ height: this.props.height, overflow: 'auto' }}>
				<ConfirmMessage
					is_show={this.state.is_show_confirm}
					message={this.props.receiver.getString('conf_del')}
					width={this.props.width}
					height={this.props.height}
					receiver={this.props.receiver}
					handleClick={this.onConfirm}
					style={{ zIndex: 2 }}
					box_style={{ zIndex: 2 }}
				/>

				<div style={{ display: 'inline-block', width: '100%' }} >
					{refresh_component}
				</div>

				<div style={{ marginLeft: 'auto', marginRight: 'auto', maxHeight: 140, marginBottom: 20, width: '90%' }}>
					<div style={{ width: '50%', display: 'inline-block' }}>
						<span id="app_version" style={{ display: this.props.receiver.is_mobile ? 'block' : 'none', fontWeight: 500 }}>{app_version}</span>
					</div>
					<div style={{ width: '50%', display: 'inline-block', textAlign: 'right' }}>
						<Dropdown
							id={'language'}
							style={{ right: 20 }}
							dropdown_style={{ marginLeft: 10, fontSize: 16, maxHeight: 'unset' }}
							header_style={{ fontSize: 20 }}
							header={this.state.language_header}
							list={list}
							handleListOnClick={this.handleChangeLanguage}
							handeListOnMove={{}}
							left={drop_down_left}
						/>
					</div>
				</div>

				{/* <div>
					<div style={{display: 'inline-block', width: this.props.width-180, }} >
						{refresh_component}
					</div>
					
					<div style={{display: 'inline-block', textAlign: 'right', width: 170, paddingTop: 20, marginRight: 10}} >
						<div style={{ display: 'inline-block' }} onClick={this.checkInternet}>
							<span className={'normal'} style={{ display: 'inline-block' }}>{this.props.receiver.getString('login_connect')}</span>
				</div>
						<Dropdown 
							id={'language'}
							style={{ right: 20 }}
							dropdown_style={{ marginLeft: 10, fontSize: 16, maxHeight: 'unset' }}
							header_style={{ fontSize: 20 }}
							header={this.state.language_header}
							list = {list}
							handleListOnClick = {this.handleChangeLanguage}
							handeListOnMove = {{}}
							left={drop_down_left}
						/>
					</div>
				</div> */}

				{/* <div style={{ paddingTop: 20, paddingRight: 20, maxHeight: 140, marginTop: 0, marginBottom: 20, textAlign: 'right' }}>

				</div> */}
				<div id='login_box' style={loginBoxStyle}>
					<div style={{ width: '100%', marginLeft: 'auto', marginRight: 'auto' }}>

						<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
							{/* <img src={this.props.receiver.app_model == 'H' ? reiri_home_logo : reiri_office_logo} style={{ width: logo_width }} onClick={this.handleClickLogo} /> */}
							<div style={{ width: logo_width }} onClick={this.handleClickLogo} >
								<img src={reiri_logo} style={{ width: logo_width/3 }} />
								<span style={{ marginLeft: 10, fontWeight: 'bold', fontSize: '120%', color: '#707070' }}>{logo}</span>
							</div>
							{/* Tommy - 15/04/2021 */}
							<span id="system_version" style={{ display: this.props.receiver.is_mobile && system_version != '' ? 'none' : 'block', position: 'relative', marginLeft: -20, fontWeight: 500 }}>{system_version}</span>
						</div>

						<div style={{ display: this.props.receiver.is_mobile ? 'block' : 'none', marginTop: 10 }}>
							<div style={{ display: 'inline-block' }} onClick={this.checkInternet}>
								<span className={'normal'} style={{ display: 'inline-block' }}>{this.props.receiver.getString('login_connect')}</span>
							</div>
							<Dropdown
								id={'connect'}
								ref={this.dropdown_ref}
								style={{ display: 'inline-block', marginLeft: 5 }}
								dropdown_style={{ right: dropdown_right_margin, maxHeight: 'unset' }}
								header_style={{ fontSize: 26 }}
								header={this.state.dropdown_header}
								list={this.state.drop_down_list}
								handleListOnClick={this.handleSwitchController}
								handeListOnMove={this.handleOnMouseMove}
								is_toggle_dropdown={this.state.is_toggle_dropdown}
							/>
						</div>
						{/* <div style={{ marginTop: this.props.receiver.is_mobile ? 0 : -50 }}> */}
						<div style={{ marginTop: '20px' }}>
							<Editbox id='usrname' placeholder={this.props.receiver.getString('usrname')} inputType='text' onChange={(event) => this.handleChangeUsername(event.target.value)} value={this.state.username} />
						</div>
						<div style={{ marginTop: '10px' }}>	
							<Editbox id='passwd' placeholder={this.props.receiver.getString('passwd')} inputType='password' onChange={(event) => this.handleChangePassword(event.target.value)} value={this.state.password} />
						</div>
						<div id='login status'>
							<span>{this.props.receiver.getString(this.state.login_status)}</span>
						</div>

						<Button id='login' style={{ width: '100%', margin: 0, marginTop: 20, marginRight: 'auto', marginLeft: 'auto', textAlign: 'center' }} bgColor={this.props.colours.appBlue} onClick={this.handleLogin}>{this.props.receiver.getString('login')}</Button>
					</div>
				</div>
				<br /><br /><br />
			</div>
		)
	}
}

